module.exports = __webpack_public_path__ + "static/media/landing-page-wave.46ea6fea.svg";